module.exports = "/img/city-florence.b26bae94.jpg";